export const CHANNEL_CONFIGS = [
  {
    slug: 'web',
    label: 'Web',
    aliases: ['web'],
  },
  {
    slug: 'whatsapp',
    label: 'WhatsApp',
    aliases: ['whatsapp'],
  },
  {
    slug: 'facebook',
    label: 'Facebook',
    aliases: ['facebook', 'facebook_messenger'],
  },
  {
    slug: 'instagram',
    label: 'Instagram',
    aliases: ['instagram'],
  },
  {
    slug: 'telegram',
    label: 'Telegram',
    aliases: ['telegram'],
  },
  {
    slug: 'sms',
    label: 'SMS',
    aliases: ['sms'],
  },
] as const

export type ChannelConfig = (typeof CHANNEL_CONFIGS)[number]
export type StandardCommunicationChannel = ChannelConfig['slug']

export const CHANNEL_LABEL_BY_SLUG: Record<
  StandardCommunicationChannel,
  string
> = CHANNEL_CONFIGS.reduce(
  (labels, config) => {
    labels[config.slug] = config.label
    return labels
  },
  {} as Record<StandardCommunicationChannel, string>
)

export const CHANNEL_ALIASES_BY_SLUG: Record<
  StandardCommunicationChannel,
  string[]
> = CHANNEL_CONFIGS.reduce(
  (aliases, config) => {
    aliases[config.slug] = config.aliases
    return aliases
  },
  {} as Record<StandardCommunicationChannel, string[]>
)

export const CHANNEL_ALIAS_TO_SLUG = CHANNEL_CONFIGS.reduce(
  (mapping, config) => {
    config.aliases.forEach(alias => {
      mapping[alias.toLowerCase()] = config.slug
    })
    return mapping
  },
  {} as Record<string, StandardCommunicationChannel>
)
